/**
 * The wire shape `Rws.AiInsights.Host.Settings.PortalSettingsAdminEndpoints` returns for the Capex budget setting: whether spend by a
 * unit marked as Capex counts against that unit's budget. Gated on `settings.write`.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The system setting for whether Capex spend counts against a budget. */
export interface CapexBudgetSetting {
  /** Whether spend by a Capex unit counts against its budget. When false, only Opex spend is set against it. */
  countsAgainstBudget: boolean;
  /** When the setting was last saved, or `null` while the default (it counts) applies. */
  updatedAt: string | null;
}

const capexBudgetPath = "/api/entitlement/settings/capex-budget";

/** Calls `GET /api/entitlement/settings/capex-budget`. */
export async function fetchCapexBudgetSetting(): Promise<AdminResult<CapexBudgetSetting>> {
  return adminRequest<CapexBudgetSetting>(capexBudgetPath, { method: "GET" }, "Capex budget setting");
}

/** Calls `PUT /api/entitlement/settings/capex-budget`. */
export async function updateCapexBudgetSetting(countsAgainstBudget: boolean): Promise<AdminResult<CapexBudgetSetting>> {
  return adminRequest<CapexBudgetSetting>(
    capexBudgetPath,
    { method: "PUT", body: JSON.stringify({ countsAgainstBudget }) },
    "Capex budget setting update",
  );
}
